import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';

export class FascicoloRicorsoGerarchico extends FascicoloFull {
    sezione: string;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
